export const NICHE_RESIDENTIAL = 1;
export const NICHE_COMMERCIAL = 2;
